<template>
    <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="8"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="i-form">
            <h3 class="h-title">业务进展情况</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>当前状态</th>
                    <td><span :style="{color:detailData.status == '2'||detailData.status == '4'?'#B82121':'#42AE0E'}">{{stateFormat(detailData.status)}}</span></td>         
                </tr>
                <tr>
                    <th>审核意见</th>
                    <td>{{exList.auditContent || '--'}}</td>         
                </tr>
                <tr>
                    <th>HASH值</th>
                    <td>{{detailData.blockchainHash}}</td>         
                </tr>
            </table>
        </div>
        <div class="i-form">
            <h3 class="h-title">数据权属确认详情</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <td colspan="3">
                        <h3>数据确权:</h3>
                    </td>
                </tr>
                <tr>
                    <th>数据权属确认服务申请书</th>
                    <td ><span class="file-link" v-if="detailData.unitSealProtocolFile[0]" @click="downloadFile(detailData.unitSealProtocolFile[0].url)">{{detailData.unitSealProtocolFile[0].name}}</span></td>         
                </tr>


                <tr>
                    <td colspan="3">
                        <h3>服务要素信息:</h3>
                    </td>
                </tr>
                <tr>
                    <th>选择律所</th>
                    <td>{{detailData.lawFirmName}}</td>
                </tr>
                <tr>
                    <th>权威节点</th>
                    <td>{{nodeFormat(detailData.authorityNode)}}</td>
                </tr>
                <tr>
                    <th>存储类型</th>
                    <td>{{typeFormat(detailData.saveType)}}</td>
                </tr>
                <tr>
                    <th>数据名称</th>
                    <td>{{detailData.dataName}}</td>
                </tr>
                <tr>
                    <th>生产方式</th>
                    <td v-if="detailData.produceMethodOther"> {{detailData.produceMethodOther}}</td>
                    <td v-else>{{detailData.produceMethod}} </td>
                </tr>
                <tr>
                    <th>权属确认类型</th>
                    <td >{{detailData.belongType}} </td>
                </tr>
                <tr>
                    <th>更新频率</th>
                    <td v-if="detailData.updateFrequencyOther"> {{detailData.updateFrequencyOther}}</td>
                    <td v-else>{{detailData.updateFrequency}} </td> 
                </tr>
                <tr>
                    <th>数据规模</th>
                    <td>{{ detailData.dataScale }}</td>
                </tr>
                
                <tr >
                    <th>预估数据价值（万元）</th>
                    <td> {{detailData.estimateDataValue}}</td>
                </tr>
                <tr >
                    <th>应用场景</th>
                    <td v-if="detailData.applicationSceneOther"> {{detailData.applicationSceneOther}}</td>
                    <td v-else>{{detailData.applicationScene}} </td>  
                </tr>
                <tr >
                    <th>是否完成合规评估</th>
                    <td >{{detailData.completeConformanceAssess}} </td>
                </tr>
                <tr >
                    <th>是否完成质量评估</th>
                    <td >{{ detailData.completeQualityAssess }} </td>
                </tr>
                <tr >
                    <th>是否完成价值评估</th>
                    <td >{{detailData.completeValueAssess}} </td>
                </tr>



                <tr>
                    <td colspan="3">
                        <h3>主体文件:</h3>
                    </td>
                </tr>
                
                
                <tr>
                    <th>三证合一</th>
                    <td ><span class="file-link" v-if="detailData.threeCertOneFile[0]" @click="downloadFile(detailData.threeCertOneFile[0].url)">{{detailData.threeCertOneFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法定代表人身份证</th>
                    <td ><span class="file-link" v-if="detailData.identityCardFile[0]" @click="downloadFile(detailData.identityCardFile[0].url)">{{detailData.identityCardFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公司简介</th>
                    <td ><span class="file-link" v-if="detailData.companyProfileFile[0]" @click="downloadFile(detailData.companyProfileFile[0].url)">{{detailData.companyProfileFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>公司简章</th>
                    <td ><span class="file-link" v-if="detailData.companyByelawFile[0]" @click="downloadFile(detailData.companyByelawFile[0].url)">{{detailData.companyByelawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>高管人员简历</th>
                    <td ><span class="file-link" v-if="detailData.ggPersonResumeFile[0]" @click="downloadFile(detailData.ggPersonResumeFile[0].url)">{{detailData.ggPersonResumeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>近两年财务报表及最近一期财务报表</th>
                    <td ><span class="file-link" v-if="detailData.financeReportFile[0]" @click="downloadFile(detailData.financeReportFile[0].url)">{{detailData.financeReportFile[0].name}}</span></td>
                </tr>  
                 <tr>
                    <th>征信报告：</th>
                    <td ><span class="file-link" v-if="detailData.creditReportFile[0]" @click="downloadFile(detailData.creditReportFile[0].url)">{{detailData.creditReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>信用报告：</th>
                    <td ><span class="file-link" v-if="detailData.xinyongReportFile[0]" @click="downloadFile(detailData.xinyongReportFile[0].url)">{{detailData.xinyongReportFile[0].name}}</span></td>
                </tr>  
                <!--
                <tr>
                    <th>DR Airating：</th>
                    <td ><span class="file-link" v-if="detailData.creditReportFile[0]" @click="downloadFile(detailData.creditReportFile[0].url)">{{detailData.creditReportFile[0].name}}</span></td>
                </tr>   -->





                 <tr>
                    <td colspan="3">
                        <h3>业务文件:</h3>
                    </td>
                </tr>
                <tr>
                    <th>数据权属确认服务申请书</th>
                    <td ><span class="file-link" v-if="detailData.unitSealProtocolFile[0]" @click="downloadFile(detailData.unitSealProtocolFile[0].url)">{{detailData.unitSealProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>数据权属确认服务申请人承诺书</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyFile[0]" @click="downloadFile(detailData.serviceApplyFile[0].url)">{{detailData.serviceApplyFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>数据权属确认服务协议</th>
                    <td ><span class="file-link" v-if="detailData.serviceProtocolFile[0]" @click="downloadFile(detailData.serviceProtocolFile[0].url)">{{detailData.serviceProtocolFile[0].name}}</span></td>
                </tr>   
                <tr>
                    <th>拟存储文件</th>
                    <td ><span class="file-link" v-if="detailData.planSaveFile[0]" @click="downloadFile(detailData.planSaveFile[0].url)">{{detailData.planSaveFile[0].name}}</span></td>
                </tr>    
            </table>
        </div>
    </el-main>
  </el-container>
</template>
<script>
    import leftMenu from './components/leftMenu'
	export default {
		name: "CDetail",
        components: {
            leftMenu
        },
		data() {
			return {
                setComdify: this.comdify,
				detailData: {},
				id: null,
				taskKey: '',
				taskId: '',
				exList: {},	
                typeOptions: [],
                stateOptions: [],
			}
    },
    created() {
        window.scrollTo(0,0);
        this.id = this.$route.query.id;
        this.$api.api.getDicts("gyl_state").then(response => {
            this.stateOptions = response.data;
        });
        this.$api.api.getDicts("save_type").then(response => {
            this.typeOptions = response.data;
        });
    },
    mounted() {
        this.getDetial();	
	},
    methods: {
        downloadFile(url){
            this.$api.api.downloadFile(url)
        },
        selectDictLabel(datas, value) {
            var actions = [];
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + value)) {
                    actions.push(datas[key].dictLabel);
                    return true;
                }
            })
            return actions.join('');
        }, 
        nodeFormat(val){
            if(val){
                let arr = JSON.parse(val)
                let nodeName = []
                arr.forEach(item => {
                    nodeName.push(item.name)
                })
                return nodeName.join('，')
            }else {
                return ''
            }
            
        },
        typeFormat (val) {
            return this.selectDictLabel(this.typeOptions, val);
        }, 
        stateFormat (val) {
            return this.selectDictLabel(this.stateOptions, val);
        }, 
        //获取详情
        getDetial() {
            this.$api.api.dataDetail(this.id).then(res => {
                this.listLoading = false;
                if(res.code==200){
                    this.detailData = Object.assign({}, res.data); 	
                    this.detailData.unitSealProtocolFile = JSON.parse(this.detailData.unitSealProtocolFile || '[]');
                    this.detailData.threeCertOneFile = JSON.parse(this.detailData.threeCertOneFile || '[]');
                    this.detailData.identityCardFile = JSON.parse(this.detailData.identityCardFile || '[]');
                    this.detailData.companyProfileFile = JSON.parse(this.detailData.companyProfileFile || '[]');
                    this.detailData.companyByelawFile = JSON.parse(this.detailData.companyByelawFile || '[]');
                    this.detailData.ggPersonResumeFile = JSON.parse(this.detailData.ggPersonResumeFile || '[]');
                    this.detailData.financeReportFile = JSON.parse(this.detailData.financeReportFile || '[]');

                    
                    this.detailData.creditReportFile = JSON.parse(this.detailData.creditReportFile || '[]');
                    this.detailData.xinyongReportFile = JSON.parse(this.detailData.xinyongReportFile || '[]');
                    // this.detailData.creditReportFile = JSON.parse(this.detailData.creditReportFile || '[]');
                    this.detailData.serviceProtocolFile = JSON.parse(this.detailData.serviceProtocolFile || '[]');
                    this.detailData.serviceApplyFile = JSON.parse(this.detailData.serviceApplyFile || '[]');
                    this.detailData.serviceApplyConfirmFile = JSON.parse(this.detailData.serviceApplyConfirmFile || '[]');
                    this.detailData.planSaveFile = JSON.parse(this.detailData.planSaveFile || '[]');
                    this.exList = res.data.contractProjectAuditList[0] || {}
                }else {
                    this.$message.error(res.msg);
                }    
            });      
        },
    }
}
</script>

<style lang="less">
@import '../style.less';
</style>